module.exports = __webpack_public_path__ + "static/media/create-video.0e0daf3a.gif";